
export class DataLayer{
    orderOportunidad($program){
        var datosDTLY = window["infoDataLayer"].oportunidad;
        var tipo = "";
        var centinela = false;
      
        var nameprog = $program.name.toUpperCase().substring(0,3);
        for(var i = 0; i < datosDTLY.length && centinela == false; i++){
                    if(datosDTLY[i].name.substring(0,3).toUpperCase() ==nameprog){
                        centinela = true;
                        return {value:datosDTLY[i].code };
                    }
        }
      
        if(centinela == false){
          for(var i = 0; i < datosDTLY.length && centinela == false; i++){
            switch(datosDTLY[i].name){
                      case 'Profesional':
                      case 'Técnico laboral':
                      case 'Tecnología':
                          tipo = "PRE";
                          break;
                      case 'Maestría':
                      case 'Especialización':
                          tipo = "POS";
                          break;
                      case 'Diplomado internacional':
                      case 'Diplomado':
                      case 'Seminario':
                      case 'Curso':
                          tipo = "EDC";
                          break;
            }
      
            if($program.oppType.toUpperCase() == tipo){
              centinela = true;
              return {value:datosDTLY[i].code };
          }
        }
      
        if(centinela == false){
          return {name:undefined, code:undefined};
        }
      }
      
      }
      
      orderTipo($program){
        var datosDTLY = window["infoDataLayer"].tipoProg;
        var tipo = "";
        var centinela = false;
      
        for(var i = 0; i < datosDTLY.length && centinela == false; i++){
          
            if ($program.name.toUpperCase().indexOf("CURSO") >= 0 && datosDTLY[i].name == "Curso") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("ESPECIALIZACIÓN") >= 0 && datosDTLY[i].name == "Especialización") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("TALLER") >= 0 && datosDTLY[i].name == "Taller") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("DOCTORADO") >= 0 && datosDTLY[i].name == "Doctorado") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("DIPLOMADO INTERNACIONAL") >= 0 && datosDTLY[i].name == "Diplomado Internacional") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("DIPLOMADO") >= 0 && datosDTLY[i].name == "Diplomado") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("MAESTRÍA") >= 0 && datosDTLY[i].name == "Maestría") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("SEMINARIO") >= 0 && datosDTLY[i].name == "Seminario") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("TECNOLOGÍA") >= 0 && datosDTLY[i].name == "Tecnología") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.name.toUpperCase().indexOf("TÉCNICO LABORAL") >= 0 && datosDTLY[i].name == "Técnico laboral") {
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.programType == "TECNI-PRE" && datosDTLY[i].name == "Técnico laboral") {
                //Profesional
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.programType == "TECNO-PRE" && datosDTLY[i].name == "Tecnología") {
                //Profesionals
                centinela = true;
                return { value: datosDTLY[i].code };
            } else if ($program.programType == "PROF-PRE" && datosDTLY[i].name == "Profesional") {
                //Profesional
                centinela = true;
                return { value: datosDTLY[i].code };

            } else if ($program.programType == "LIC-PRE" && datosDTLY[i].name == "Licenciatura") {
                //Profesional
                centinela = true;
                return { value: datosDTLY[i].code };

            } else if ($program.programType == "PRE-PRE" && datosDTLY[i].name == "Pregrado") {
                //Profesional
                centinela = true;
                return { value: datosDTLY[i].code };

            } else if ($program.programType == "CC-PE" && datosDTLY[i].name == "Curso") {
                //Profesional
                centinela = true;
                return { value: datosDTLY[i].code };

            }

        }
        if(centinela == false){
          return {name:undefined, code:undefined};
        }
      }
      
      orderProgCor($code){
        var datosDTLY = window["infoDataLayer"].programasNC;
        var tipo = "";
        var centinela = false;
      
        for(var i = 0; i < datosDTLY.length && centinela == false; i++){
          if($code == datosDTLY[i].code){
            centinela = true;
            return {value:datosDTLY[i].nameCorto };
          }
        }
      
        if(centinela == false){
          return {name:undefined, code:undefined};
        }
      
      }
      
      orderModalidad($program){
        var datosDTLY = window["infoDataLayer"].modalidad;
        var tipo = "";
        var centinela = false;
      
        for(var i = 0; i < datosDTLY.length && centinela == false; i++){
          if($program.modality.substring(0,3) == datosDTLY[i].code.substring(0,3).toUpperCase()){
            centinela = true;
            return {value:datosDTLY[i].code };
          }
        }
      
        if(centinela == false){
          return {name:undefined, code:undefined};
        }
      
      }
      
      orderDoc($doc){
        var tiposDoc = [];
        tiposDoc[0]={code:'CC',  name:'Cédula de Ciudadanía'};
        tiposDoc[1]={code:'TI',   name:'Tarjeta de Identidad'};
        tiposDoc[2]={code:'PAS',  name:'Pasaporte'};
        tiposDoc[3]={code:'CE',   name:'Cédula de Extranjería'};
        var centinela = false;
        
        for(var i = 0; i < tiposDoc.length && centinela == false; i++){
          if($doc == tiposDoc[i].code){
            centinela = true;
            return {value:tiposDoc[i].name };
          }
        }
        
        
        if(centinela == false){
          return {name:undefined, code:undefined};
        }
        
      
      }

}